/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Price_Period_FreeInputs */



/**
* | output |
* | --- |
* | "USD · free forever" |
*
* @param {Signup_Price_Period_FreeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_price_period_free = /** @type {((inputs?: Signup_Price_Period_FreeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Price_Period_FreeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("USD · gratuit, sans limite de durée")
	if (locale === "de") return /** @type {LocalizedString} */ ("USD · dauerhaft kostenlos")
	if (locale === "it") return /** @type {LocalizedString} */ ("USD · gratis per sempre")
	if (locale === "ru") return /** @type {LocalizedString} */ ("USD · бесплатно навсегда")
	if (locale === "es") return /** @type {LocalizedString} */ ("USD · gratis para siempre")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("USD · 永久免费")
	if (locale === "ja") return /** @type {LocalizedString} */ ("USD・ずっと無料")
	if (locale === "hi") return /** @type {LocalizedString} */ ("USD · हमेशा मुफ़्त")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("USD · gratuito para sempre")
	return /** @type {LocalizedString} */ ("USD · free forever")
});